import { Component, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-channels-cell-renderer",
  templateUrl: "./channels-cell-renderer.component.html",
  styleUrls: ["./channels-cell-renderer.component.scss"],
})
export class ChannelsCellRendererComponent implements OnDestroy{
  mini: boolean;
  availableChannels = {
    "Amazon.com": {
      url: "/assets/images/channel-logos/amazon-logo.svg",
      miniUrl: '/assets/images/account-dropdown/amazon.png',
      miniWidth: '13px',
      width: "30px",
      largeWidth:"43.43px"
    },
    "Amazon": {
      url: "/assets/images/channel-logos/amazon-logo.svg",
      miniUrl: '/assets/images/account-dropdown/amazon.png',
      miniWidth: '13px',
      width: "30px",
      largeWidth:"43.43px"
    },
    walmart: {
      url: "/assets/images/channel-logos/walmart-logo.svg",
      miniUrl: '/assets/images/account-dropdown/walmart.png',
      miniWidth: '13px',
      width: "30px",
      largeWidth:"62.5px"
    },
    Walmart: {
      url: "/assets/images/channel-logos/walmart-logo.svg",
      miniUrl: '/assets/images/account-dropdown/walmart.png',
      miniWidth: '13px',
      width: "30px",
      largeWidth:"62.5px"
    },
    Ebay: {
      url: "/assets/images/account-dropdown/ebay.png",
      miniUrl: "/assets/images/account-dropdown/ebay.png",
      miniWidth: '13px',
      width: "30px",
      largeWidth:"43.43px"
    },
    Wholesale: {
      url: "/assets/images/account-dropdown/wholesale.png",
      miniUrl: "/assets/images/account-dropdown/wholesale.png",
      miniWidth: '13px',
      width: "30px",
      largeWidth:"43.43px"
    },
    "My Channel": {
      url: "/assets/images/account-dropdown/wholesale.png",
      miniUrl: "/assets/images/account-dropdown/wholesale.png",
      miniWidth: '13px',
      width: "30px",
      largeWidth:"43.43px"
    },
  };
  channels = [];
  params: any;
  private destroy$ = new Subject<void>();

  agInit(params: any): void {
    this.params = params;
    this.mini = params.mini;
    this.params.channels.sort().forEach((element) => {
      if (this.availableChannels[element]) {
        this.channels.push(this.availableChannels[element]);
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
